// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Aufgabe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteAufgabe(): (aufgabeId: string) => Promise<Aufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId) => (await getAPI()).aufgaben.deleteAufgabe({ aufgabeId }),
    [getAPI]
  );
}
